import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "cc_token";
const USER_KEY = "cc_user";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
};

export const userStore = {
  get: () => {
    const v = localStorage.getItem(USER_KEY);
    return v ? JSON.parse(v) : null;
  },
  set: (u) => localStorage.setItem(USER_KEY, JSON.stringify(u)),
};

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const t = tokenStore.get();
  // Skip stale-token attachment for endpoints that authenticate via body —
  // a bad token shouldn't be able to lock a user out of /auth/login.
  const skipAuth = cfg.url && /^\/?(auth\/(login|register|reset-password|verify-reset)|register)/.test(cfg.url);
  if (t && !skipAuth) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      tokenStore.clear();
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/register")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);
